import { effects } from 'redux-saga'
import { push as pushPath } from 'react-router-redux'

import {editSignup, revisitingSignup, setAddressLocId} from '../../modules/signupEdit/actions'

export default function* continueSignup(action) {
  yield effects.put.resolve(editSignup(action.payload.id))
  yield effects.put.resolve(revisitingSignup())
  const state = yield effects.select()
  const signup = state.signupEdit.get('edit')
  if (signup.addressLocId) {
    yield effects.put.resolve(setAddressLocId(signup.addressLocId));
  }
  yield effects.put.resolve(pushPath('/account'))
  yield effects.call(() => document.getElementById('wrapper').scrollIntoView())
}



// WEBPACK FOOTER //
// ./src/redux/sagas/signupEdit/continueSignup.js